import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { WarningAmber as WarningIcon } from '@mui/icons-material';
import { constants } from '../constants';
var ConfirmationDialog = function ConfirmationDialog(_ref) {
    var isOpen = _ref.isOpen, setIsOpen = _ref.setIsOpen, bodyText = _ref.bodyText, submitFunction = _ref.submitFunction, submitButtonText = _ref.submitButtonText, loading = _ref.loading, _ref$actionType = _ref.actionType, actionType = _ref$actionType === void 0 ? 'delete' : _ref$actionType;
    // Define colors based on action type
    var getActionColors = function getActionColors() {
        switch (actionType) {
            case 'save':
            case 'discard':
                return {
                    iconColor: '#26890D',
                    // Green
                    iconBgColor: '#e8f5e8',
                    submitBgColor: '#26890D',
                    submitBorderColor: '#26890D'
                };
            case 'delete':
            default:
                return {
                    iconColor: '#da291c',
                    // Red from Figma design
                    iconBgColor: '#fdeaea',
                    submitBgColor: '#da291c',
                    submitBorderColor: '#da291c'
                };
        }
    };
    var colors = getActionColors();
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: isOpen,
        onClose: function onClose() {
            return setIsOpen(false);
        },
        maxWidth: "xs",
        fullWidth: true,
        "data-testid": "confirmation-dialog",
        sx: {
            '& .MuiDialog-paper': {
                borderRadius: '8px',
                boxShadow: '0px 0px 2px 0px rgba(0,0,0,0.12), 0px 4px 8px 0px rgba(0,0,0,0.14)',
                padding: 0,
                backgroundColor: '#ffffff'
            }
        }
    }, /*#__PURE__*/ React.createElement(DialogContent, {
        sx: {
            px: 2,
            py: 3,
            textAlign: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 72,
            height: 72,
            borderRadius: '50%',
            backgroundColor: colors.iconBgColor,
            border: "2px solid ".concat(colors.iconColor)
        }
    }, /*#__PURE__*/ React.createElement(WarningIcon, {
        sx: {
            color: colors.iconColor,
            fontSize: 32
        }
    })), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            px: 2
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: "#212121",
        fontWeight: 600
    }, bodyText)))), /*#__PURE__*/ React.createElement(DialogActions, {
        sx: {
            px: 3,
            py: 2,
            gap: 2,
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: function onClick() {
            return setIsOpen(false);
        },
        variant: "outlined",
        disabled: loading,
        sx: {
            minHeight: '40px',
            borderRadius: '2px',
            textTransform: 'none',
            fontFamily: 'Open Sans',
            fontSize: '16px',
            fontWeight: 400,
            px: 1.5,
            py: 1,
            borderColor: colors.submitBorderColor,
            color: colors.submitBgColor,
            letterSpacing: '0.15px',
            lineHeight: 1.52,
            flex: 1,
            '&:hover': {
                borderColor: colors.submitBorderColor,
                backgroundColor: 'rgba(218, 41, 28, 0.04)'
            }
        }
    }, constants.cancel), /*#__PURE__*/ React.createElement(Button, {
        onClick: submitFunction,
        variant: "contained",
        disabled: loading,
        sx: {
            minHeight: '40px',
            borderRadius: '2px',
            textTransform: 'none',
            fontFamily: 'Open Sans',
            fontSize: '16px',
            fontWeight: 400,
            px: 1.5,
            py: 1,
            backgroundColor: colors.submitBgColor,
            color: '#ffffff',
            letterSpacing: '0.15px',
            lineHeight: 1.52,
            flex: 1,
            boxShadow: 'none',
            '&:hover': {
                backgroundColor: actionType === 'delete' ? '#b71c1c' : '#1e7b0d',
                boxShadow: 'none'
            },
            '&:disabled': {
                backgroundColor: '#e0e0e0',
                color: '#999'
            }
        }
    }, loading ? constants.processing : submitButtonText)));
};
export { ConfirmationDialog };
